<template>
    <div class="block_container">
        <van-tabbar v-model="activeTab">
            <van-tabbar-item icon="home-o">分类</van-tabbar-item>
            <van-tabbar-item icon="todo-list-o">流程</van-tabbar-item>
        </van-tabbar>
        <van-tabs v-if="activeTab==0" v-model="active" :border="false">
            <van-tab v-for="(comfort,index) in comforts" :key="index" :title="comfort.type">
                <van-cell title="标准/人" :value="comfort.standard" style="text-align:left;" />
                <van-cell title="慰问对象" :value="comfort.target" style="text-align:left;" />
                <van-cell title="需提供材料" is-link arrow-direction="down" style="text-align:left;" />
                <van-cell v-for="(req,idx) in comfort.requirements" :key="idx" :value="req"
                    :border="false" style="padding: 10px 40px;text-align:right;" icon="success" />
                <van-cell title="慰问形式" :value="comfort.methods" style="text-align:left;" />
                <van-cell title="慰问期限" :value="comfort.limits" style="text-align:left;" />
            </van-tab>
        </van-tabs>
        <div v-if="activeTab==1">
            <van-nav-bar title="申请流程" />
            <van-steps direction="vertical" :active="activeStep">
                <van-step v-for="(step,i) in applySteps" :key="i"
                    style="text-align:left;padding: 20px 20px">{{step}}</van-step>
            </van-steps>
        </div>
    </div>
</template>
<script>
import { NavBar, Cell, CellGroup, Tab, Tabs,
         Step, Steps, Tabbar, TabbarItem } from 'vant';

export default {
    name: 'Comforts',
    data () {
      return {
          active: 1,
          activeTab: 0,
          activeStep: 0,
          applySteps: [
              "员工提交慰问对应材料给工会小组长",
              "工会小组长提交材料至工会指定委员批复",
              "工会委员邮件批复",
              "工会小组长将材料原件提交工会Summer",
              "工会Summer每周四负责报销转账"
          ],
          comforts: [
              {
                  type: "思科宝宝",
                  standard: "500/人",
                  target: "所有180regular员工",
                  requirements: [
                    "出院小结复印件或新生儿出生证明复印件",
                    "报销申请单",
                    "生育相关慰问品购买发票"
                  ],
                  methods: "实物(由员工所在工会小组长购买)",
                  limits: "出院后的6个月内"
              },
              {
                  type: "生病慰问",
                  standard: "1000/人",
                  target: "所有180regular员工",
                  requirements: [
                    "出院小结复印件",
                    "报销申请单",
                    "实物慰问还需提供慰问品购买发票"
                  ],
                  methods: "现金(银行转账)或者实物(由员工所在工会小组长购买)",
                  limits: "出院后的6个月内"
              },
              {
                  type: "大病慰问",
                  standard: "2000/人",
                  target: "所有180regular员工",
                  requirements: [
                    "出院小结复印件",
                    "医院窗口开出的大病医保证明",
                    "报销申请单",
                    "实物慰问还需提供慰问品购买发票"
                  ],
                  methods: "现金(银行转账)或者实物(由员工所在工会小组长购买)",
                  limits: "出院后的6个月内"
              }
          ]
      };
    },
    mounted() {
        setInterval(this.updateSteps, 1500);
    },
    methods: {
        updateSteps() {
            if (this.activeStep >= 4) {
                this.activeStep = 0;
            } else {
                this.activeStep += 1;
            }
        }
    }
}
</script>
<style scoped>
.block_container {
    background-color: #f7f8fa;
    font-size: 14px;
    line-height: 26px;
}
</style>


// WEBPACK FOOTER //
// src/components/Comforts.vue